import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../styles/About.css';

const About = () => {
  const [services, setServices] = useState([]);
  const [formData, setFormData] = useState({
    name: '',
    mobile: '',
    email: '',
    purpose: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const navigate = useNavigate();

  // ---------------- FETCH SERVICES FROM DB ----------------
  useEffect(() => {
    const fetchServices = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_SERVICES_API}`);
        if (res.data.services) setServices(res.data.services);
      } catch (err) {
        console.error('Failed to fetch services:', err);
      }
    };
    fetchServices();
  }, []);

  // ---------------- HANDLE INPUT CHANGE ----------------
const handleChange = (e) => {
  const { name, value } = e.target;
  setFormData(prev => ({
    ...prev,
    [name]: value   // ← REMOVE .trim()
  }));
};


  // ---------------- HANDLE FORM SUBMIT ----------------
const handleSubmit = async (e) => {
  e.preventDefault();

  const payload = {
    name: formData.name.trim(),
    email: formData.email.trim(),
    phone: formData.mobile.trim(),
    purpose: formData.purpose.trim()
  };

  if (!payload.name || !payload.email || !payload.phone) {
    alert("Name, Email & Mobile are required!");
    return;
  }

  try {
    const res = await axios.post(
      `${process.env.REACT_APP_CONTACT_API_URL}?action=add`,
      payload,
      { headers: { "Content-Type": "application/json" } }
    );

    if (res.data.success) {
      setSubmitted(true);
      setFormData({ name: '', mobile: '', email: '', purpose: '' });
      setTimeout(() => setSubmitted(false), 3000);
    } else {
      alert(res.data.message || "Failed to submit form.");
    }
  } catch (err) {
    alert("Something went wrong. Please try again.");
  }
};


  return (
    <div className="about-container">
      {/* About Section */}
      <section className="about-section">
        <h1 className="about-section-head">About Our Firm</h1>
        <h6 className="about-section-sub-head">Tax TimeZ</h6>
        <div className="about-headings"><h1>History</h1></div>
        <p className="about-section-para">
Founded in 2019 by CA Anil Kumar, Taxtimez was established with the vision of delivering
reliable, transparent, and client-focused tax and financial solutions. With strong professional
expertise and deep industry knowledge, the firm was created to bridge the gap between complex
regulatory requirements and practical business needs. </p>
<p className="about-section-para">Under the leadership of CA Anil Kumar, Taxtimez has grown into a trusted service provider,
supporting individuals, startups, and organizations with accurate tax planning, compliance
management, and financial advisory services. The firm follows a structured, technology-driven
approach to ensure efficiency, accuracy, and timely service delivery.</p>
<p className="about-section-para">At Taxtimez, we prioritize integrity, confidentiality, and professional excellence. Every client
engagement is handled with a customized strategy, ensuring solutions that align with business
goals while maintaining full regulatory compliance.</p>
<p className="about-section-para">Our commitment to continuous improvement, innovation, and quality service has enabled
Taxtimez to build long-term relationships and a strong reputation in the financial services sector.
We remain focused on empowering our clients with clarity, confidence, and sustainable financial
growth.        </p>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="about-headings"><h1>Our Mission</h1></div>
        <p className="about-section-para">
          Our mission is to empower our clients with the knowledge and strategies they need to navigate the complex world of taxation and finance. We are committed to providing exceptional service, building long-term relationships based on trust and integrity, and helping our clients achieve their financial goals.
        </p>
      </section>

      {/* Services Section */}
     {/* Services Section */}
<section className="services-section">
  <div className="about-headings"><h1>Our Services</h1></div>

  <div className="services-grid">
    {services.map(service => (
      <div
        key={service.id}
        className="service-item"
        onClick={() => navigate(`/services`)}
        style={{ cursor: 'pointer' ,color:"white"}}
      >
        {service.title}
      </div>
    ))}
  </div>
</section>


      {/* Contact Section */}
      <section className="contact-section">
        <div className="about-headings"><h1>Contact Us</h1></div>
        <p className="about-section-para">
          We're here to help! Contact us today to schedule a consultation and discover how CA Shoaib & Associates can assist you with your tax and financial needs.
        </p>

        <div className="about-form">
          <form className="contact-form" onSubmit={handleSubmit}>
            <label htmlFor="name">Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              placeholder="Enter your name"
              value={formData.name}
              onChange={handleChange}
              required
            />

            <label htmlFor="mobile">Mobile Number *</label>
            <input
              type="tel"
              id="mobile"
              name="mobile"
              placeholder="Enter mobile number"
              value={formData.mobile}
              onChange={handleChange}
              pattern="[0-9]{10}"
              required
            />

            <label htmlFor="email">Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              required
            />

            <label htmlFor="purpose">Purpose</label>
            <input
              type="text"
              id="purpose"
              name="purpose"
              placeholder="Enter purpose of contact"
              value={formData.purpose}
              onChange={handleChange}
            />

            <button type="submit">Submit</button>
          </form>

          {submitted && (
            <p className="thankyou-msg">Thank you! We'll get back to you soon.</p>
          )}
        </div>
      </section>
    </div>
  );
};

export default About;
